import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { isTesting, macroCondition } from '@embroider/macros';

export default class TimeZoneSelectorComponent extends Component {
  @service intl;
  @service clock;

  get clockFace() {
    if (this.clockFaceHour > 12) {
      return this.clockFaceHour - 12;
    } else {
      return this.clockFaceHour;
    }
  }

  get clockFaceHour() {
    return this.intl
      .formatDate(this.clock.date, {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: this.clock.timeZone,
      })
      .split(':')[0];
  }

  get userShortTimeZone() {
    return this.intl.formatTimeZone(new Date(), this.clock.userTimeZone, 'short');
  }

  get userTimeZone() {
    return this.intl.formatTimeZone(new Date(), this.clock.userTimeZone, 'long');
  }

  get stationShortTimeZone() {
    if (this.args.station) {
      return this.intl.formatTimeZone(new Date(), this.args.station?.localTimeZone, 'short');
    }
    return '';
  }

  get stationTimeZone() {
    if (this.args.station) {
      return this.intl.formatTimeZone(new Date(), this.args.station?.localTimeZone, 'long')
    }
    return ''
  }

  get showTimeZoneSelector() {
    return (
      this.args.station &&
      (this.args.showSelector ||
        this.clock.timeZone != this.args.station?.localTimeZone ||
        this.clock.timeZone != this.clock.userTimeZone)
    );
  }

  @action
  showTimeZoneMessage() {
    if (macroCondition(isTesting())) {
      return;
    }

    if (this.showTimeZoneSelector) {
      later(() => {
        const el = document.querySelector('#time_zone_popup_anchor');
        let instance = tippy(el, {
          content: this.alertMessage,
          closeOnClick: true,
          showOnCreate: true,
          allowHTML: true,
          closeDelay: 5000,
          theme: 'attention',
          placement: 'bottom-end',
          delay: 1000,
          onClickOutside(instance /*, event */) {
            instance.destroy();
          },
          onHidden() {
            instance.destroy();
          },
        });
      }, 1500);
    }
  }

  @action
  useLocalTime() {
    this.clock.timeZone = this.clock.userTimeZone;
  }

  @action
  useStationTime() {
    this.clock.timeZone = this.args.station?.localTimeZone;
  }
}
